__turbopack_context__.v({
  "card": "tutorial-steps-module__vdvSQa__card",
  "grid": "tutorial-steps-module__vdvSQa__grid",
  "heading": "tutorial-steps-module__vdvSQa__heading",
  "number": "tutorial-steps-module__vdvSQa__number",
  "points": "tutorial-steps-module__vdvSQa__points",
  "result": "tutorial-steps-module__vdvSQa__result",
  "tutorial": "tutorial-steps-module__vdvSQa__tutorial",
});
